import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-paging',
  templateUrl: './paging.component.html'
})
export class PagingComponent implements OnInit {

  @Input() pageIndex: number = 0;
  @Input() pageCount: number = 0;
  @Output() page = new EventEmitter<number>();

  startPage = 0;
  endPage = 0;
  maxPages = 5
  pages: number[] = [];

  lang = 'en'; // localStorage.getItem('language') || 'en';


  constructor() { }

  ngOnInit(): void {
    this.paginate();
  }

  paginate() {
    let totalPages = this.pageCount;
    let currentPage = this.pageIndex;
    let maxPages = this.maxPages;

    if (currentPage < 0) {
        currentPage = 0;
    } else if (currentPage > totalPages) {
        currentPage = totalPages;
    }

    if (totalPages <= maxPages) {
        // total pages less than max so show all pages
        this.startPage = 0;
        this.endPage = totalPages;
    } else {
        // total pages more than max so calculate start and end pages
        let maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
        let maxPagesAfterCurrentPage = Math.ceil(maxPages / 2);
        if (currentPage <= maxPagesBeforeCurrentPage) {
            // current page near the start
            this.startPage = 0;
            this.endPage = maxPages;
        } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
            // current page near the end
            this.startPage = totalPages - maxPages;
            this.endPage = totalPages;
        } else {
            // current page somewhere in the middle
            this.startPage = currentPage - maxPagesBeforeCurrentPage;
            this.endPage = currentPage + maxPagesAfterCurrentPage;
        }
    }

    // create an array of pages to ng-repeat in the pager control
    this.pages = Array.from(Array(this.endPage - this.startPage).keys()).map(i => this.startPage + i);
  }
}
